import React from "react";
import DocumentTemplatesTable from "../../containers/DocumentTemplates/DocumentTemplatesTable";

const DocumentTemplatesPage = () => {
  return (
    <>
      <DocumentTemplatesTable />
    </>
  );
};

export default DocumentTemplatesPage;
